<template>
  <div
    style="overflow: hidden;"
    :style="{
      margin: margin,
      borderRadius: hasBorder ? borderRadius : null,
      border: hasBorder ? border : null,
      textAlign: textAlign,
      width: width,
      padding: padding,
      background: backgroundGradient
        ? `radial-gradient(ellipse at center bottom, ${backgroundGradient.int} 0%, ${backgroundGradient.ext} 200%)`
        : null,
    }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'LayoutBlock',
  props: {
    borderRadius: {
      type: String,
      default: '6px',
    },
    margin: {
      type: String,
      default: '48px 0',
    },
    hasBorder: {
      type: Boolean,
      default: false,
    },
    border: {
      type: String,
      default: '1px solid #e5e8ee',
    },
    textAlign: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '100%',
    },
    backgroundGradient: {
      type: Object,
    },
    padding: {
      type: String,
      default: '0',
    },
  },
}
</script>
